import { EntityService } from '../../core/services/entity.service';
import { GlobalService } from '../../core/services/global.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { Insured } from '../model/insured';

@Injectable()
export class InsuredService {

    constructor(private http: GlobalService, private entityService: EntityService) {
    }

    getCurrent(): Observable<Insured> {
        const url = `insureds`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<Insured>(res))
            .map(dataItem => this.entityService.copy(dataItem, new Insured()));
    }

    update(insured: Insured): Observable<boolean> {
        const url = `insureds`;
        return this.http.put(url, insured)
            .map(res => this.entityService.extractData<boolean>(res));
    }

    dataCheck(): Observable<any> {
        const url = `insureds/dataCheck`;
        return this.http.get(url).map(res => {
            const payload = res.payload as Response;
            let body = payload && payload.json ? payload.json() : false;

            return body;
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/insured.service.ts